__turbopack_context__.v({
  "active": "component-module-scss-module__KI5NnW__active",
  "releasesDescription": "component-module-scss-module__KI5NnW__releasesDescription",
  "releasesRepository": "component-module-scss-module__KI5NnW__releasesRepository",
  "releasesRepositoryDetails": "component-module-scss-module__KI5NnW__releasesRepositoryDetails",
  "releasesRepositoryExpanded": "component-module-scss-module__KI5NnW__releasesRepositoryExpanded",
  "releasesRepositoryHeader": "component-module-scss-module__KI5NnW__releasesRepositoryHeader",
});
